const ramps = {
  adding_title: "Set the availability hours and time slot lengths for each ramp",
  your_ramps: "Your ramps",
  names_info: "Note! If the name of your ramp exceeds five characters, it will be displayed as an index",
  no_ramps_in_warehouse: "No ramps in the warehouse",
  fill_ramps: "Fill in ramps",
  no_ramps: "No ramps",
  no_ramps_error: "You must add at least one ramp",
  filled: "Ramp completed",
  empty: "Ramp not completed",
  error: "Error while filling in",
  saved: "Changes saved successfully.",
  current: "Currently selected ramp",
  confirmRamps: "Confirm adding calendar",
  adding_ramps_title: "Enter ramp names",
  adding_ramp_title: "Enter ramp name",
  adding_ramps_subtitle:
    "Note! Make sure the ramp names are identical to the physical ramp names in your warehouse. Otherwise, carriers may not be able to find the correct ramp.",
  ramp_number: "Ramp number",
  ramp_name: "Ramp name",
  ramp: "Ramp",
  ramp_adding: "Add ramp",
  ramp_name_error: "Ramp name cannot be empty",
  manage_ramps: "Manage ramps",
  pick_ramp: "Select ramp",
  pick_ramp_to_accept_monitory: "Select the ramp where the carrier will perform the check-in.",
  no_ramps_for_monitory: "You have no available ramps at ",
  no_ramps_for_monitory_2: "Add time slots for the ramp to accept more check-ins.",
  ramp_delete_confirmation:
    "Are you sure you want to delete this ramp? All calendars and check-ins created for it will be deleted. Are you sure you want to continue?",
  errors: {
    empty: "To add a calendar, you must complete each ramp",
    error: "Incorrectly filled ramps.",
    single_ramp: "Incorrect ramp",
  },
};

export default ramps;
